// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react: true*/
import React, {useContext, useMemo, useRef} from 'react';
import {useHistory} from 'react-router-dom';
// @ts-ignore
import {useTranslation, Trans} from 'react-i18next';
import cn from 'classnames';
import {App_context} from 'hola_app_context';
import {Settings_context} from '../settings_ctx';
import {Cards, i_card} from '../ui/cards';
import {Editor} from '../../../shared/editor/editor';
// @ts-ignore
import Arrow_img from '../img/homepage/how_it_works_arrow.svg';
import {use_section_scroll} from '../lib/use_section_scroll';
import {use_product_info} from '../ui/use_product_info';
import zutil from '/util/util.js';
import hopt from 'hola_opt';
import {use_download} from '../shared/use_download';
import styles from './how_it_works_banner.module.less';

interface i_how_it_works_props {
    cls?: string;
    is_promo_browser?: boolean;
    user_country?: string;
    treshold_abs?: number;
    app_fixed?: string;
    on_click?: ()=>void;
    fixed_cards?: {id: string; img?: string}[];
    title_h3?: boolean;
    with_margin_after_icon?: boolean;
    with_anim?: boolean
    imgs?: {[key: string]: JSX.Element};
}

const How_it_works = (props: i_how_it_works_props)=>{
    const {is_promo_browser, user_country, treshold_abs, app_fixed,
        with_anim = true, imgs} = props;
    // @ts-ignore
    const {host} = useContext(App_context);
    const {theme} = useContext(Settings_context);
    useTranslation();
    const ref = useRef();
    const history = useHistory();
    const anim = zutil.get(hopt, 'www_hola.animation.how_it_works', {});
    if (with_anim)
    {
        use_section_scroll(ref, false, {treshold: 0.7, duration: 1200,
            translate: 200, treshold_abs: treshold_abs||-150, part: 'top',
            ...anim});
    }
    const {app, store, href, device, os} = use_product_info({host,
        download_browser: is_promo_browser, user_country, app_fixed});
    const download = use_download();
    const on_click = event=>{
        if (props.on_click)
        {
            event.preventDefault();
            return props.on_click();
        }
        if (app=='vpn' || app=='browser')
        {
            event.preventDefault();
            download[app=='vpn' ? 'download' : 'download_br']({cb: ()=>{
                history.push(href);
            }});
        }
    };
    const is_exe = ['vpn', 'browser'].indexOf(app)>=0;
    const card_keys = useMemo<{id: string; img?: string}[]>(()=>{
        if (props.fixed_cards)
            return props.fixed_cards;
        const download_id = ['ios', 'android'].includes(os) ? `download_${os}`
            : `download_${app}`;
        const download_img = app=='mobile' ? 'download_mobile'
            : is_exe ? 'download_exe'
            : 'download';
        const c1 = {id: download_id, img: download_img};
        const c2 = app=='mobile' ? {id: 'country_mobile', img: 'country'}
            : is_exe ? {id: 'extension', img: 'download'}
            : {id: 'country'};
        const c3 = {id: 'access'};
        return [c1, c2, c3];
    }, [os, app, is_exe]);
    const cards: i_card[] = card_keys.map(c=>{
        const img = imgs ? imgs[c.id] :
            `homepage/how_it_works_${c.img||c.id}.svg`;
        return {
            id: c.id,
            title: <Trans i18nKey={ `hp.how_it_works.${c.id}.title`}
              components={{Download_link: <a className={styles.text_link}
              href={href} onClick={on_click}/>}}/>,
            text: <Trans i18nKey={ `hp.how_it_works.${c.id}.text`}
              components={{Download_link: <a className={styles.text_link}
              href={href} onClick={on_click}/>}} values={{store, device}}/>,
            img: img,
        };
    });
    const cls = {
        container: cn(styles.cards,
            props.with_margin_after_icon && styles.with_margin_after_icon),
        title: cn(theme.u2),
        text: cn(theme.p2, theme.reg),
        img: styles.img,
    };
    const spacer = <div className={styles.arrow}><Arrow_img/></div>;
    return <div ref={ref} className={cn(theme.container, theme.block,
      props.cls, styles.how_it_works)}>
      {props.title_h3 ? <h3 className={styles.h3}>How it works</h3> :
        <h2>How it works</h2>}
      <Cards cards={cards} cls={cls} spacer={spacer}/>
    </div>;
};

export const How_it_works_impl = ()=>{
    const fixed_cards = useMemo(()=>{
        return [
            {id: 'product_browser', img: 'product_desktop'},
            {id: 'country'},
            {id: 'access'},
        ];
    }, []);
    return <How_it_works is_promo_browser={false} app_fixed="browser"
      user_country={hopt.user_country} treshold_abs={300}
      fixed_cards={fixed_cards}
      cls={styles.how_it_works}
      title_h3 with_margin_after_icon/>;
};

interface i_how_it_works_editor_props {
    value: unknown;
    on_change: (new_val: unknown)=>void;
}

export const How_it_works_editor = (props: i_how_it_works_editor_props)=>{
    const {value, on_change} = props;
    return <Editor value={value} on_change={on_change} editors={[]}/>;
};
